export default function Philosophy() {
  return (
    <section className="py-24 px-8 bg-gray-50">
      <div className="max-w-[1200px] mx-auto">
        <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-16 text-center">
          私たちの理念
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-white p-8 rounded-lg">
            <div className="w-16 h-16 bg-primary/10 rounded-lg flex items-center justify-center mb-6">
              <i className="ri-lightbulb-line text-3xl text-primary"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">
              AI×経験のハイブリッド
            </h3>
            <p className="text-base text-gray-600 leading-relaxed">
              最新のAI技術による客観的なデータ分析と、30年の実務経験から得た知見を組み合わせ、確実に成果を出す施策を提案します。
            </p>
          </div>
          
          <div className="bg-white p-8 rounded-lg">
            <div className="w-16 h-16 bg-primary/10 rounded-lg flex items-center justify-center mb-6">
              <i className="ri-focus-3-line text-3xl text-primary"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">
              優先順位の明確化
            </h3>
            <p className="text-base text-gray-600 leading-relaxed">
              やるべきことを増やすのではなく、やらないことを決める。限られたリソースを最も効果的な施策に集中させます。
            </p>
          </div>
          
          <div className="bg-white p-8 rounded-lg">
            <div className="w-16 h-16 bg-primary/10 rounded-lg flex items-center justify-center mb-6">
              <i className="ri-rocket-line text-3xl text-primary"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">
              設計から実装まで
            </h3>
            <p className="text-base text-gray-600 leading-relaxed">
              戦略立案だけで終わらせず、実装・運用まで一気通貫でサポート。確実に前に進める伴走型のコンサルティングを提供します。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
